import {
  CropOriginalOutlined,
  PeopleAltOutlined,
  SelectAll,
} from "@mui/icons-material";
import DoneIcon from "@mui/icons-material/Done";
import { areaOfActivity, DonationStatus, EntityType } from "./common/enum";
import Donation from "./Containers/DonationView";

export const profileOptions = {
  question: "profileQuestion",
  property: "entity_type",
  options: [
    {
      img: "/static/register/donor.png",
      title: "donor",
      body: "",
      value: EntityType.donor,
    },
    {
      img: "/static/register/donorReciever.png",
      title: "distributor",
      body: "",
      value: EntityType.distributor,
    },
    {
      img: "/static/register/donorDistributor.png",
      title: "donorDistributor",
      body: "",
      value: EntityType.donorDistributor,
    },
    {
      img: "/static/register/Pata.svg",
      title: "alernativeTexTitle",
      body: "SubTitleSpecialDist",
      value: EntityType.specialDistributor,
    },
  ],
};
export const eventData = {
  entityId: "D14445515",
  date: "27/03/2000 10.00",
  comments:
    'The actual Latin sentence that the start of lorem ipsum text comes from reads as follows: "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, ...',
};

export const activityOptions = {
  question: "activityQuestion",
  property: "area_of_activity",
  options: [
    {
      img: "/static/register/production.png",
      title: "production",
      value: areaOfActivity.production,
    },
    {
      img: "/static/register/industry.png",
      title: "industry",
      value: areaOfActivity.industry,
    },
    {
      img: "/static/register/retailer.png",
      title: "retailer",
      value: areaOfActivity.retailer,
    },
    {
      img: "/static/register/icon-hotelaria.svg",
      title: "hotel",
      value: areaOfActivity.hotel,
    },
    {
      img: "/static/register/icon-restauracao.svg",
      title: "restaurants",
      value: areaOfActivity.restaurants,
    },
    {
      img: "/static/register/icon-catering.svg",
      title: "catering",
      value: areaOfActivity.catering,
    },
    {
      img: "/static/register/publicEntities.png",
      title: "publicEntities",
      value: areaOfActivity.publicEntities,
    },
    {
      img: "/static/register/feedBank.png",
      title: "feedBank",
      value: areaOfActivity.feedBank,
    },
    {
      img: "/static/register/ipss.png",
      title: "ipss",
      value: areaOfActivity.ipss,
    },
    {
      img: "/static/register/other.png",
      title: "other",
      value: areaOfActivity.other,
    },
  ],
};
export const activityOptionsHibrid = {
  question: "activityQuestion",
  property: "area_of_activity",
  options: [
    {
      img: "/static/register/feedBank.png",
      title: "feedBank",
      value: areaOfActivity.feedBank,
    },
    {
      img: "/static/register/ipss.png",
      title: "ipss",
      value: areaOfActivity.ipss,
    },
    {
      img: "/static/register/publicEntities.png",
      title: "publicEntities",
      value: areaOfActivity.publicEntities,
    },
    {
      img: "/static/register/other.png",
      title: "other",
      value: areaOfActivity.other,
    }
  ],
};
export const activityRecieverOptions = {
  question: "activityQuestion",
  property: "area_of_activity",
  options: [
    {
      img: "/static/register/feedBank.png",
      title: "feedBank",
      value: areaOfActivity.feedBank,
    },
    {
      img: "/static/register/ipss.png",
      title: "ipss",
      value: areaOfActivity.ipss,
    },
    {
      img: "/static/register/other.png",
      title: "otherReceiver",
      value: areaOfActivity.other,
    },
  ],
};

export const activitySpecialRecieverOptions = {
  question: "activityQuestion",
  property: "area_of_activity",
  options: [
    {
      img: "/static/register/canil-gatil.png",
      title: "kennel",
      value: areaOfActivity.kennel,
    },
    {
      img: "/static/register/Zoologico.png",
      title: "zoo",
      value: areaOfActivity.zoo,
    },
    {
      img: "/static/register/other.png",
      title: "other",
      value: areaOfActivity.other,
    },
  ],
};

export const entityTypeOptions = {
  question: "entityTypeQuestion",
  property: "is_group_entity",
  options: [
    {
      img: "/static/register/groupUnitManagement.png",
      title: "groupUnitManangement",
      value: true,
    },
    {
      img: "/static/register/store.png",
      title: "store",
      value: false,
    },
  ],
};

export const entityData = {
  property: "entity_address",
  question: "entityDataQuestion",
};

export const platformOptions = {
  question: "platformQuestion",
  options: [
    {
      title: "platformNotification",
      sub: "platformNotificationSub",
    },
    {
      title: "platformUserMessage",
      sub: "platformUserMessageSub",
    },
  ],
  platformDescription: "platformDescription",
  platformConfirmation: "platformConfirmation",
  termsAndConditions: "termsAndConditions",
};

export const actionViewTabs = [
  { id: "1", title: "Details" },
  { id: "2", title: "Articles" },
  { id: "3", title: "Messages" },
];

export const dashboardMenu = [
  {
    title: "home",
    link: "/dashboard",
    icon: "/static/dashboard/icon-nav--home.svg",
  },
  // {
  //   title: "history",
  //   // link: "/profile",
  //   icon: "/static/dashboard/history.svg",
  //   type: EntityType.donor,
  // },
  {
    title: "donations",
    icon: "/static/dashboard/icon-nav--doacoes.svg",
    // type: EntityType.donor,
    link: "/dashboard/donations",
  },
  {
    title: "actions",
    link: "/dashboard/agenda",
    icon: "/static/dashboard/icon-nav--agenda.svg",
  },
  {
    title: "profile",
    link: "/dashboard/profile",
    icon: "/static/dashboard/icon-nav--perfil.svg",
  },
  {
    title: "manageBranches",
    link: "/dashboard/manage-branches",
    icon: "/static/dashboard/icon-nav--estabelecimentos.svg",
  },
  {
    title: "manageManagers",
    link: "/dashboard/manage-managers",
    icon: "/static/dashboard/icon-nav--utilizadores.svg",
  },
  {
    title: "settings",
    link: "/dashboard/settings",
    icon: "/static/dashboard/icon-nav--definicoes.svg",
  },
];

export const adminDashboardMenu = [
  {
    title: "organizations",
    // link: "/dashboard",
    icon: "",
  },
];

export const organizationDashboardMenu = [
  {
    title: "pendingApplication",
    // link: "/dashboard",
    icon: "",
  },
  {
    title: "Contas não verificadas",
    // link: "/dashboard",
    icon: "",
  },
  {
    title: "allOrganizations",
    // link: "/dashboard",
    icon: "",
  },
];

export const donationDashboardMenu = [
  {
    title: "myDonation",
    icon: "",
    value: DonationStatus.new,
    link: "/dashboard/donations/my-donations",
  },
  {
    title: "history",
    icon: "",
    value: DonationStatus.expired,
    link: "/dashboard/donations/history",
  },
];

export const donationFilterMenu = [
  {
    title: "actives",
    value: DonationStatus.new,
    isAnimal: "",
  },
  {
    title: "reserved",
    value: DonationStatus.reservation,
    isAnimal: "",
  },
  {
    title: "activeAltenativeCanal",
    value: DonationStatus.new,
    isAnimal: "true",
  },
  {
    title: "reservedAltenativeCanal",
    value: DonationStatus.reservation,
    isAnimal: "true",
  },
];

export const donationHistoryFilterMenu = [
  {
    title: "Expiradas",
    value: DonationStatus.expired,
  },
  {
    title: "Canceladas",
    value: DonationStatus.cancel,
  },
  {
    title: "Recolhidas",
    value: DonationStatus.collected,
  },
];

export const stats = [
  {
    title: "Doações",
    number: 49,
    //growthRate: "3%",
    icon: "/static/register/donor.png",
  },
  {
    title: "Eventos",
    number: 92,
    //growthRate: "42%",
    icon: "/static/dashboard/icon-evento.svg",
  },
  {
    title: "Reservadas",
    number: 7186,
    //growthRate: "19%",
    //icon: "/static/dashboard/scheduleAction.svg",
    icon: "/static/dashboard/calendar.png",
  },
  {
    title: "Recolhidas",
    number: 18,
    //growthRate: "-2%",
    icon: "/static/dashboard/donationdDelivered.svg",
  },
];

export const onGoingDonations = [
  {
    ticketNumber: "D0967652",
    date: "2020-01-01",
    categories: ["Produto fresco", "Lacticínios e Ovos"],
    images: [],
  },
  {
    ticketNumber: "D0967652",
    date: "2020-01-01",
    categories: ["Produto fresco", "Lacticínios e Ovos"],
    images: [],
  },
  {
    ticketNumber: "D0967652",
    date: "2020-01-01",
    categories: ["Produto fresco", "Lacticínios e Ovos"],
    images: [],
  },
];

export const messages = [
  {
    name: "Rita Lopes",
    profile: "/static/dashboard/avatars/avatar_1.jpg",
    message: "Enviou uma mensagem sobre a doação",
    ticketNumber: "D0967670",
    time: "5 min",
  },
  {
    name: "DAFOOD",
    profile: "/static/dashboard/avatars/avatar_2.jpg",
    message: "Enviou uma mensagem sobre a doação",
    ticketNumber: "D0967670",
    time: "5 min",
  },
  {
    name: "100%REFOOD",
    profile: "/static/dashboard/avatars/avatar_3.jpg",
    message: "Enviou uma mensagem sobre a doação",
    ticketNumber: "D0967670",
    time: "5 min",
  },
];

export const items = [
  {
    productName: "Laranjas",
    productImage: "/static/dashboard/items/laranjas.png",
    productCateogaries: [
      {
        name: "Frutas e Legumes",
        icon: "/static/dashboard/items/frutas.png",
      },
    ],
  },
];

export const headerData = [
  { headerName: "ID", field: "id" },
  { headerName: "Name", field: "name" },
  { headerName: "Type", field: "type" },
  { headerName: "Area Of Activity", field: "areaOfActivity" },
  { headerName: "Entity Type", field: "entityType" },
  { headerName: "Action", cellRenderer: "iconComponent", filter: false },
];

export const entityRowData = [
  {
    id: "EJD55",
    name: "FUTURIONC Inc.",
    type: "COLLECTOR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "ADK55",
    name: "FOOD PAND Inc.",
    type: "COLLECTOR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "DJJ64",
    name: "ALIBABA Inc.",
    type: "COLLECTOR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "LIS65",
    name: "INDIA  Inc.",
    type: "DONAR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "OLK98",
    name: "BANGLADESH Inc.",
    type: "COLLECTOR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "ABC12",
    name: "DELHI PRIVATE Inc.",
    type: "DONAR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "DCH89",
    name: "SUNDORI Inc.",
    type: "DONAR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "EJD55",
    name: "FUTURIONC Inc.",
    type: "COLLECTOR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "ADK55",
    name: "LOST PAND Inc.",
    type: "COLLECTOR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "DJJ64",
    name: "ANG Inc.",
    type: "COLLECTOR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "LIS65",
    name: "CDDC  Inc.",
    type: "DONAR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "OLK98",
    name: "BBC Inc.",
    type: "COLLECTOR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "ABC12",
    name: "UNI PRIVATE Inc.",
    type: "DONAR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
  {
    id: "DCH89",
    name: "United State Inc.",
    type: "DONAR",
    areaOfActivity: "Other",
    entityType: "Individual",
  },
];
